export const MASTER_PATH = "/master"
export const MASTER_ORGANIZATION_PATH="/master/organization"